import {parseJson} from "@common/TypesHelper";
import {AxiosInstance} from "axios";
import {SignalRBackendMethod} from "@api/repositories/reatime-repository/types";
import {RealtimeConnection} from "@api/repositories/reatime-repository/RealtimeConnection";

export class RealTimeMethodsInvoker {
    constructor(
        private readonly client: AxiosInstance,
        private connection: RealtimeConnection
    ) {
    }

    /**
     * Invokes the given method on the backend via signalr
     * @param signalRMethod
     * @param channels
     * @private
     */
    private async invoke(signalRMethod: SignalRBackendMethod, channels: string[]) {

        const sessionId = (this.client as any).getToken();

        if(!sessionId) {return;}

        let res = await this.connection.hub.invoke(signalRMethod, sessionId, channels);

        res = parseJson(res);

        if (this.isUnauthorized(res)) {
            return (this.client as any).refreshToken()
                .then(() => this.invoke(signalRMethod, channels))
                .catch(() => false);
        }
        return res;
    }

    // подписка на канал в signal-r
    async subscribe(channels: string[]) {
        return this.invoke(SignalRBackendMethod.Subscribe, channels);
    }

    // отписка от канала signal-r
    async unsubscribe(channels: string[]) {
        return this.invoke(SignalRBackendMethod.Unsubscribe, channels);
    }

    private isUnauthorized(data: any) {
        return data && (data as any).error && (data as any).error.code === 401;
    }
}
